<script setup lang="ts">
import { getOppositeParticipant } from '@collector/shared-ui-domain'
import Select from '@mobile/components/Select/Select.vue'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import PlayerSelectGroup from './PlayerSelectGroup.vue'

interface Props {
  name: string
  linkedIncident: ProbableLinkedIncident
}

const props = defineProps<Props>()

// composables
const { probableHomeParticipant, probableAwayParticipant } =
  useEventInjections()

// data
const oppositeParticipant = getOppositeParticipant(
  props.linkedIncident.participant!.id,
  probableHomeParticipant.value,
  probableAwayParticipant.value,
)

// model
const model = defineModel<InstanceType<typeof Select>['$props']['value']>()
</script>

<template>
  <PlayerSelectGroup
    v-model="model"
    :name
    :participant="oppositeParticipant"
    prioritizeGoalkeepers
  />
</template>
